import axios from 'axios'
import {
    Message,
    Loading
} from 'element-ui';
import router from '../router'

// let loading //定义loading变量

function startLoading() { //使用Element loading-start 方法
  return;
  // loading = Loading.service({
  //     lock: true,
  //     text: '加载中...',
  //     background: 'rgba(0, 0, 0, 0.7)'
  // })
}

function endLoading() { //使用Element loading-close 方法
  return;
  // loading.close()
}

// 请求拦截  设置统一header
axios.interceptors.request.use(config => {
  // 加载
  startLoading()
  if (isPhone())
    config.headers.logindevice = "phone";
  config.headers.loginmethod = "front";
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截  401 token过期处理
axios.interceptors.response.use(response => {
  endLoading()
  return response.data
}, error => {
  // 错误提醒
  endLoading()
  Message.error(error.response.data.error)

  const {
    status
  } = error.response
  if (status == 401) {
    Message.error('token值无效，请重新登录')
    // 清除token
    localStorage.removeItem('eleToken')

    // 页面跳转
    router.push('/login')
  }
  if (status == 400) {
    return Promise.reject(error);
  }
  return Promise.reject(error)
})
function isPhone() {
  var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null
}
export default axios